import { useDispatch, useSelector } from 'react-redux';
import {
  setTableSearch,
  setTableSelectedTemplate,
  setModelAssociationSearchTemplate,
  setTemplateListSearch,
  setEntityRelationshipListSearch,
  setAppManagementSearch,
  setWorkFlowListSearch,
  setRulesSearch,
  setUserListSearch,
  setGroupListSearch,
  setDocumentInventorySearch,
  setDashboardSearch,
  setDashboardActiveFilter,
  setDocumentTemplateSearch,
  setUserSetting,
  setFreshUserSetting,
  setUserRoleListSearch,
  setIssueTypeListSearch,
  setSummaryTabsListSearch,
  setIsWorkflowCompiled,
  setIsDraftWorkflowSaved,
  setModelRequestSearch,
  setAccessRequestSearch,
  setModelArchivedSearch,
  setUseCaseSearch,
  setQuerySearch,
  setTriggerThemeChange,
  setTriggerProductIconChange,
  setTriggerHeaderIconChange,
  setEmailTemplateListSearch,
  setSectionPermissions,
  setWorkflowGroupNodes,
  setCurrentWorkflowGroupId,
} from '../store/slices/commonSlicer';

export default function useCommon() {
  const dispatch = useDispatch();
  // @ts-ignore
  const { common } = useSelector((state) => state);
  return {
    dispatch,
    common,
    setTableSearch,
    setTableSelectedTemplate,
    setModelAssociationSearchTemplate,
    setTemplateListSearch,
    setEntityRelationshipListSearch,
    setAppManagementSearch,
    setWorkFlowListSearch,
    setRulesSearch,
    setUserListSearch,
    setGroupListSearch,
    setDocumentInventorySearch,
    setDashboardSearch,
    setDashboardActiveFilter,
    setDocumentTemplateSearch,
    setUserSetting,
    setFreshUserSetting,
    setUserRoleListSearch,
    setIssueTypeListSearch,
    setSummaryTabsListSearch,
    setIsWorkflowCompiled,
    setIsDraftWorkflowSaved,
    setModelRequestSearch,
    setAccessRequestSearch,
    setModelArchivedSearch,
    setUseCaseSearch,
    setQuerySearch,
    setTriggerThemeChange,
    setTriggerProductIconChange,
    setTriggerHeaderIconChange,
    setEmailTemplateListSearch,
    setSectionPermissions,
    setWorkflowGroupNodes,
    setCurrentWorkflowGroupId,
  };
}
